import { render, staticRenderFns } from "./give-ticket.vue?vue&type=template&id=4a0b8e8e"
import script from "./give-ticket.vue?vue&type=script&lang=js"
export * from "./give-ticket.vue?vue&type=script&lang=js"
import style0 from "./give-ticket.vue?vue&type=style&index=0&id=4a0b8e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports